/**
 * Extracts the endpoint name from an error URL that starts with /api
 * @param {string} url - The error URL (e.g., '/api/getEnrollmentItems/:Australia/:D100/:en-US')
 * @returns {string} The endpoint name (e.g., 'getEnrollmentItems') or empty string if not an API URL
 */
export function extractEndpointName(url) {
  if (!url || typeof url !== 'string') {
    return '';
  }

  // Only process URLs that start with /api
  if (!url.startsWith('/api/')) {
    return '';
  }

  // Split by '/' and get the endpoint name (second part after /api/)
  const parts = url.split('/');
  return parts[2] || '';
}

/**
 * Examples:
 * extractEndpointName('/api/getEnrollmentItems/:Australia/:D100/:en-US') -> 'getEnrollmentItems'
 * extractEndpointName('/api/getMoneyInfo/:Australia') -> 'getMoneyInfo'
 * extractEndpointName('/api/getUserInfo/:123') -> 'getUserInfo'
 * extractEndpointName('/some/other/url') -> '' (not an API URL)
 * extractEndpointName('getData') -> '' (not an API URL)
 */
